var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7128 10.9125L10.9203 15.705C9.87031 16.755 8.14532 16.755 7.08782 15.705L2.29531 10.9125C1.24531 9.8625 1.24531 8.13751 2.29531 7.08001L7.08782 2.2875C8.13782 1.2375 9.86281 1.2375 10.9203 2.2875L15.7128 7.08001C16.7628 8.13751 16.7628 9.8625 15.7128 10.9125Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeDark);
export default __webpack_public_path__ + "static/media/shape-dark.5ba607808552000a1d9a48976b74fcd3.svg";
export { ForwardRef as ReactComponent };